<template>
  <b-modal
    v-model="activModel"
    :title="`${type == 'ADD' ? 'إضافة' : 'تعديل'}`"
    centered
    footer-class="removed"
    class="edit-modal"
    id="modal"
    size="md"
    no-close-on-backdrop
  >
    <validation-observer ref="statisticsValidation">
      <b-form @submit.prevent>
        <form-input
          rules="required"
          id="name"
          label="العنوان"
          v-model="title"
        />

        <form-mask
          label="العدد"
          id="number_statistics"
          v-model="number_statistec"
          :raw="false"
          placeholder="10,000"
          options="number"
          rules="required"
        />

        <form-select
          v-model="selectedIcon"
          :options="arrayIcons"
          rules="required"
          label="الأيقونة"
          :getOptionLabel="(x) => x.title"
          :reduce="(x) => x.icon"
        >
          <template #option="{ title, icon }">
            <div :key="title" :id="title">
              <feather-icon :icon="icon" size="16" class="align-middle mr-50" />
              <span> {{ title }}</span>
            </div>
          </template>
        </form-select>

        <div class="justify-content-end d-flex pt-50 align-items-center">
          <b-button
            @click="activModel = false"
            variant="outline-secondary"
            class=""
          >
            <feather-icon icon="XIcon" />
            إلغاء
          </b-button>
          <save-btn
            class="ml-1"
            variant="primary"
            style="height: 40px"
            @click="formSubmitCreate()"
            type="submit"
          >
          </save-btn>
        </div>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import saveBtn from "@/components/loader-btn";
import vSelect from "vue-select";
import { BModal, BForm, BButton, BFormGroup } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import FormInput from "@/components/form-input/index.vue";
import Cleave from "vue-cleave-component";
import "cleave.js/dist/addons/cleave-phone.us";
import FormSelect from "@/components/form-select/index.vue";
import FormMask from "@/components/form-mask";

export default {
  components: {
    BModal,
    BForm,
    ValidationProvider,
    ValidationObserver,
    FormInput,
    BButton,
    BFormGroup,
    Cleave,
    vSelect,
    saveBtn,
    FormSelect,
    FormMask,
  },
  props: {
    type: {
      type: String,
    },
    item: Object,
    value: Boolean,
  },
  data: () => {
    return {
      title: "",
      number_statistec: 0,
      arrayIcon:
        "ActivityIcon AirplayIcon AlertCircleIcon AlertOctagonIcon AlertTriangleIcon AlignCenterIcon AlignJustifyIcon AlignLeftIcon AlignRightIcon AnchorIcon ApertureIcon ArchiveIcon ArrowDownCircleIcon ArrowDownLeftIcon ArrowDownRightIcon ArrowDownIcon ArrowLeftCircleIcon ArrowLeftIcon ArrowRightCircleIcon ArrowRightIcon ArrowUpCircleIcon ArrowUpLeftIcon ArrowUpRightIcon ArrowUpIcon AtSignIcon AwardIcon BarChart2Icon BarChartIcon BatteryChargingIcon BatteryIcon BellOffIcon BellIcon BluetoothIcon BoldIcon BookOpenIcon BookIcon BookmarkIcon BoxIcon BriefcaseIcon CalendarIcon CameraOffIcon CameraIcon CastIcon CheckCircleIcon CheckSquareIcon CheckIcon ChevronDownIcon ChevronLeftIcon ChevronRightIcon ChevronUpIcon ChevronsDownIcon ChevronsLeftIcon ChevronsRightIcon ChevronsUpIcon ChromeIcon CircleIcon ClipboardIcon ClockIcon CloudDrizzleIcon CloudLightningIcon CloudOffIcon CloudRainIcon CloudSnowIcon CloudIcon CodeIcon CodepenIcon CodesandboxIcon CoffeeIcon ColumnsIcon CommandIcon CompassIcon CopyIcon CornerDownLeftIcon CornerDownRightIcon CornerLeftDownIcon CornerLeftUpIcon CornerRightDownIcon CornerRightUpIcon CornerUpLeftIcon CornerUpRightIcon CpuIcon CreditCardIcon CropIcon CrosshairIcon DatabaseIcon DeleteIcon DiscIcon DivideCircleIcon DivideSquareIcon DivideIcon DollarSignIcon DownloadCloudIcon DownloadIcon DribbbleIcon DropletIcon Edit2Icon Edit3Icon EditIcon ExternalLinkIcon EyeOffIcon EyeIcon FacebookIcon FastForwardIcon FeatherIcon FigmaIcon FileMinusIcon FilePlusIcon FileTextIcon FileIcon FilmIcon FilterIcon FlagIcon FolderMinusIcon FolderPlusIcon FolderIcon FramerIcon FrownIcon GiftIcon GitBranchIcon GitCommitIcon GitMergeIcon GitPullRequestIcon GithubIcon GitlabIcon GlobeIcon GridIcon HardDriveIcon HashIcon HeadphonesIcon HeartIcon HelpCircleIcon HexagonIcon HomeIcon ImageIcon InboxIcon InfoIcon InstagramIcon ItalicIcon KeyIcon LayersIcon LayoutIcon LifeBuoyIcon Link2Icon LinkIcon LinkedinIcon ListIcon LoaderIcon LockIcon LogInIcon LogOutIcon MailIcon MapPinIcon MapIcon Maximize2Icon MaximizeIcon MehIcon MenuIcon MessageCircleIcon MessageSquareIcon MicOffIcon MicIcon Minimize2Icon MinimizeIcon MinusCircleIcon MinusSquareIcon MinusIcon MonitorIcon MoonIcon MoreHorizontalIcon MoreVerticalIcon MousePointerIcon MoveIcon MusicIcon Navigation2Icon NavigationIcon OctagonIcon PackageIcon PaperclipIcon PauseCircleIcon PauseIcon PenToolIcon PercentIcon PhoneCallIcon PhoneForwardedIcon PhoneIncomingIcon PhoneMissedIcon PhoneOffIcon PhoneOutgoingIcon PhoneIcon PieChartIcon PlayCircleIcon PlayIcon PlusCircleIcon PlusSquareIcon PlusIcon PocketIcon PowerIcon PrinterIcon RadioIcon RefreshCcwIcon RefreshCwIcon RepeatIcon RewindIcon RotateCcwIcon RotateCwIcon RssIcon SaveIcon ScissorsIcon SearchIcon SendIcon ServerIcon SettingsIcon Share2Icon ShareIcon ShieldOffIcon ShieldIcon ShoppingBagIcon ShoppingCartIcon ShuffleIcon SidebarIcon SkipBackIcon SkipForwardIcon SlackIcon SlashIcon SlidersIcon SmartphoneIcon SmileIcon SpeakerIcon SquareIcon StarIcon StopCircleIcon SunIcon SunriseIcon SunsetIcon TabletIcon TagIcon TargetIcon TerminalIcon ThermometerIcon ThumbsDownIcon ThumbsUpIcon ToggleLeftIcon ToggleRightIcon ToolIcon Trash2Icon Trash2Icon TrelloIcon TrendingDownIcon TrendingUpIcon TriangleIcon TruckIcon TvIcon TwitchIcon TwitterIcon TypeIcon UmbrellaIcon UnderlineIcon UnlockIcon UploadCloudIcon UploadIcon UserCheckIcon UserMinusIcon UserPlusIcon UserXIcon UserIcon UsersIcon VideoOffIcon VideoIcon VoicemailIcon Volume1Icon Volume2Icon VolumeXIcon VolumeIcon WatchIcon WifiOffIcon WifiIcon WindIcon XCircleIcon XOctagonIcon XSquareIcon XIcon YoutubeIcon ZapOffIcon ZapIcon ZoomInIcon ZoomOutIcon",
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
      selectedIcon: null,
    };
  },

  methods: {
    formSubmitCreate() {
      this.$refs.statisticsValidation.validate().then(async (success) => {
        if (success) {
          if (this.type == "ADD") {
            this.createStatistics();
          } else {
            this.editStatistics();
          }
        }
      });
    },
    formSubmitEdit() {
      this.$refs.statisticsValidation.validate().then(async (success) => {
        if (success) {
          this.editStatistics();
        }
      });
    },

    createStatistics() {
      this.$store
        .dispatch("manageInterfaceNgo/statistics/createStatistics", {
          icon: this.selectedIcon,
          title: this.title,
          count: this.number_statistec.replace(/\D/g, ""),
        })
        .then((res) => {
          this.unFilter();
        });
      this.activModel = false;
    },
    editStatistics() {
      this.$store.dispatch("manageInterfaceNgo/statistics/updateStatistics", {
        id: this.item.id,
        data: {
          icon: this.selectedIcon,
          title: this.title,
          count: this.number_statistec.replace(/\D/g, ""),
        },
      });
      this.activModel = false;
    },
    unFilter() {
      this.number_statistec = null;
      this.title = "";
      this.selectedIcon = "";
    },
  },
  computed: {
    activModel: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },

    arrayIcons() {
      const splitArray = this.arrayIcon.split(" ");
      return splitArray.map((item) => ({
        title: item,
        icon: item,
      }));
    },
  },
  created() {
    if (this.type == "edit") {
      this.number_statistec = this.item.count;
      this.title = this.item.title;
      this.selectedIcon = this.item.icon;
    }
  },
};
</script>
